export default "__VITE_PUBLIC_ASSET__3f4aef2b__"